import Ownership from "./Ownership";

export default Ownership;
